// extracted by mini-css-extract-plugin
export default {"modal":"app-documents-FolderCreateModal-FolderCreateModal-module__jpTOgT_nDifhqTrZG6PV","field":"app-documents-FolderCreateModal-FolderCreateModal-module__HlQTQbhgwyolobzOtrWx"};